/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Reconnect_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to reconnect the space. Please try again." |
*
* @param {Spaces_Reconnect_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_reconnect_error = /** @type {((inputs?: Spaces_Reconnect_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Reconnect_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuverbinden des Spaces fehlgeschlagen. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Failed to reconnect the space. Please try again.")
});